import { useState } from "react";
import { Text } from "./Text";

/** Contract HTML is produced by the escaped, immutable server renderer. The
 * sandbox keeps previews inert even if a later template is accidentally unsafe. */
export function DocumentPreview({ title, html, url, image = false }: { title: string; html?: string; url?: string; image?: boolean }) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (image && url) return <div className="v365-document-image">{failedUrl === url ? <Text variant="callout" tone="secondary">This image preview is unavailable. Use Download file to open the saved document.</Text> : <img src={url} alt={title} referrerPolicy="no-referrer" onError={() => setFailedUrl(url)} />}</div>;
  return <iframe className="v365-document-preview" title={title} sandbox="" referrerPolicy="no-referrer" {...(html !== undefined ? { srcDoc: html } : { src: url })} />;
}
